import React from "react";
import { LAPSED_COACH_INTERVAL_DAYS, UserRole } from "../constants";
import { UserInfoDto } from "@growth-machine-llc/stridist-api-client";
import dayjs from "dayjs";

export type UserInfo = Omit<UserInfoDto, "init" | "toJSON">;

export const CurrentUserContext = React.createContext<UserInfo>(null);

export function useCurrentUser() {
  return React.useContext(CurrentUserContext);
}

export function useUserIsClient() {
  const user = useCurrentUser();

  return user && user.role === UserRole.CLIENT;
}

export function useCurrentUserId() {
  const user = useCurrentUser();

  return user && user.id;
}

export function useCurrentUserExternalId() {
  const user = useCurrentUser();

  return user && user.externalReferenceId;
}

export function useCoachIsImpersonating() {
  const user = useCurrentUser();

  return user && (user.isSample || user.isImpersonating);
}

export function useCurrentUserRole() {
  const user = useCurrentUser();

  return user && user.role;
}

export function useUserIsLapsedCoach() {
  const user = useCurrentUser();

  if (!user || user.role !== UserRole.COACH) {
    return false;
  }

  if (!user.subscription) {
    return true;
  }

  const periodEnd = dayjs(user.subscription.periodEndDate);
  const lapsedCoachInterval = dayjs().subtract(
    LAPSED_COACH_INTERVAL_DAYS,
    "days",
  );

  return periodEnd.isBefore(lapsedCoachInterval);
}
